/**
 * Helper compartilhado pelos 3 modais de acao do tenant (TASK-2437).
 *
 * Trata o caso especial dos endpoints partial (501 NotImplemented) com toast
 * amarelo + mensagem clara. Demais erros caem em toast vermelho generico.
 */

import { notifications } from '@mantine/notifications'

export function handleProvisioningActionError(err: unknown): void {
  const status =
    (err as { response?: { status?: number } })?.response?.status ?? null
  const detail =
    (err as { response?: { data?: { detail?: unknown } } })?.response?.data
      ?.detail

  if (status === 501) {
    notifications.show({
      color: 'yellow',
      title: 'Endpoint reservado',
      message:
        typeof detail === 'string' && detail.length > 0
          ? detail
          : 'Endpoint reservado; sera implementado em sub-task.',
    })
    return
  }

  if (status === 503) {
    notifications.show({
      color: 'red',
      title: 'Recurso indisponível',
      message:
        'O provisioning v2 esta desativado neste ambiente (feature flag).',
    })
    return
  }

  if (status === 429) {
    notifications.show({
      color: 'red',
      title: 'Muitas requisições',
      message: 'Aguarde alguns segundos e tente novamente.',
    })
    return
  }

  if (status === 403) {
    notifications.show({
      color: 'red',
      title: 'Sem permissão',
      message: 'Seu usuário não tem a permissão necessária.',
    })
    return
  }

  if (status === 422 && Array.isArray(detail)) {
    notifications.show({
      color: 'red',
      title: 'Dados inválidos',
      message: detail
        .map(
          (d: { loc?: unknown; msg?: unknown }) =>
            `${(Array.isArray(d.loc) ? d.loc : []).join('.')}: ${d.msg}`,
        )
        .join('\n'),
    })
    return
  }

  notifications.show({
    color: 'red',
    title: 'Falha na operação',
    message:
      typeof detail === 'string'
        ? detail
        : err instanceof Error
          ? err.message
          : String(err),
  })
}
